// src/app/store.ts
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice';
import dialogsSlice from './dialog/dialogsSlice';
import userReducer from './user/userSlice';
import businessTagSliceReducer from './businessTag/businessTagSlice';
import businessSliceReducer from './business/businessSlice';
import permissionSliceReducer from './permission/permissionSlice';
import statsSliceReducer from './stats/statsSlice';
import supplierSliceReducer from './suplier/suplierSlice';
import filterItemsSliceReducer from './filterItem/filterItemsSlice';
import subscriptionPlanSliceReducer from './subscriptionPlan/subscriptionPlanSlice';
import eventSliceReducer from './event/eventSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    users: userReducer,
    dialogs: dialogsSlice,
    businessTag: businessTagSliceReducer,
    business: businessSliceReducer,
    permission: permissionSliceReducer,
    stats: statsSliceReducer,
    supplier: supplierSliceReducer,
    filterItems: filterItemsSliceReducer,
    subscriptionPlan: subscriptionPlanSliceReducer,
    event: eventSliceReducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false,
    });
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
